<div>
  Hochladen der Belege DIREKT nachdem sie in der App eingetroffen sind, ohne Belegfreigabe (das Feature ist dann
  gratis).
</div>
